<template>
    <!-- DAU地图分布 -->
    <div>
        <div class="data-panel" style="margin:0">
            <div class="data-panel-header">
                <h2>{{title}}</h2>
                <div class="extra">
                    <template v-if="display === 'table'">
                        <a-button @click="exportToExcel('dau_table', `${$service.PROJ_CODE}-DAU地图分布-${map==='world'?'世界地图':'中国地图'}-${date.format('YYYY-MM-DD')}`)" :title="$t('common.downloadData')"><a-icon type="download"/></a-button>
                        <a-button @click="copy('dau_table')" id="copy-btn" style="margin:0 16px 0 8px;" :title="$t('common.copyData')"><a-icon type="copy"/></a-button>
                    </template>
                    <a-radio-group v-model="map">
                        <a-radio-button value="world">{{$t(`fixed.online.map.world`)}}</a-radio-button>
                        <a-radio-button value="china">{{$t(`fixed.online.map.china`)}}</a-radio-button>
                    </a-radio-group>
                    <a-date-picker v-model="date" :allowClear="false" style="margin:0 0 0 8px;" />
                    <a-radio-group v-model="display" style="margin:0 0 0 16px;">
                        <a-radio-button value="chart">{{ $t('common.chart') }}</a-radio-button>
                        <a-radio-button value="table">{{ $t('common.table') }}</a-radio-button>
                    </a-radio-group>
                </div>
            </div>
            <div class="data-panel-content fixed-data-panel-content">
                
                <a-spin :spinning="loading" tip="数据加载中..." class="loading" >
                    <chart :datas="china_datas" :conf="china_chart" :height="450"  :delay="1000" :fields="fields" class="fixed-chart" :class="{hidepanel:display!=='chart' || map!=='china'}"/>
                    <chart :datas="world_datas" :conf="world_chart" :height="450" :delay="1000" :fields="fields" class="fixed-chart" :class="{hidepanel:display!=='chart' || map!=='world'}"/>
                
                    <data-table :fields="fields" :datas="map==='china'?china_datas:world_datas" ref="dau_table"  class="fixed-datatable" :class="{hidepanel:display!=='table'}"/>
                </a-spin>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment"
import {datatableMixin} from '@/components/common/datatable/datatableMixin.js'
import Chart from '@/components/common/chart/chart.vue'
import DataTable from '@/components/common/datatable.vue'
import { ChinaCityLang, worldNamesDict } from '@/constants/geoMap';

export default {
    name: 'mapPanel',
    mixins: [datatableMixin],
    inject: ['today', 'yesterday', 'ranges'],
    components: {
        Chart,
        DataTable,
    },
    props: {
        // 数据接口
        api: {
            type: String,
        },
        // 标题
        title: {
            type: String,
        },
        searchers: {
            type: Object,
            default: ()=>{return {}},
        }
    },
    data() {
        return {
            loading: true,
            api: 'online_dau',
            display: 'chart',
            show: false,
            map: 'china',
            date: this.yesterday,
            fields: [
                {id:'name', title: this.$t("fixed.online.map.area"), width:'50%'},
                {id:'value', title: this.$t("fixed.online.map.cnt"), width:'50%'},
            ],
            world_date: null,
            world_chart: {
                type: `worldmap`,
                x: {id: 'name', title: this.$t("fixed.online.map.area")},
                y: {id: 'value', title: this.$t("common.value")},
                color: null,
                series: null,
                label: false,
                slider: false,
                legend: false,
            },
            china_date: null,
            china_chart: {
                type: `chinamap`,
                x: {id: 'name', title: this.$t("fixed.online.map.area")},
                y: {id: 'value', title: this.$t("common.value")},
                color: null,
                series: null,
                label: false,
                slider: false,
                legend: false,
            },
            world_datas: [],
            china_datas: [],
        }
    },
    watch: {
        date() {
            this.loading = true
            setTimeout(()=>this.getData(), 500)
        },
        map() {
            let dt = this.date.format('YYYY-MM-DD')
            if(this.map==='world' && this.world_date===dt) {
                return
            }
            if(this.map==='china' && this.china_date===dt) {
                return
            }
            this.show = false
            this.loading = true
            setTimeout(()=>this.getData(), 500)
        }
    },
    computed: {
        chart() {
            return {
                type: `${this.map}map`,
                x: {id: 'name', title: this.$t("fixed.online.map.area")},
                y: {id: 'value', title: this.$t("common.value")},
                color: null,
                series: null,
                label: false,
                slider: false,
                legend: false,
            }
        }
    },
    mounted() {
        // 处理默认地图
        if(this.searchers.map && this.searchers.map.default) {
            this.map = this.searchers.map.default
        }

        // 处理时间
        if(this.searchers.date && this.searchers.date.default) {
            this.date = moment(this.searchers.date.default)
        }
        this.getData()
    },
    methods: {
        getData() {
            let dt = this.date.format('YYYY-MM-DD')
            let type = this.map
            this.loading = true
            this.$service.query_fixed_module(this.api, {dt, type}).then((data)=>{
                if(type=='world') {
                    this.world_date = dt
                    if (this.$i18n.locale === 'en_US') {
                        this.world_datas = data.map(d => ({
                            ...d,
                            name: d.name && worldNamesDict.cn2en[d.name] ? worldNamesDict.cn2en[d.name] : d.name
                        }));
                    } else {
                        this.world_datas = data;
                    }
                    
                }
                else {
                    this.china_date = dt
                    if (this.$i18n.locale === 'en_US') {
                        this.china_datas = data.map(d => ({
                            ...d,
                            name: d.name && ChinaCityLang[d.name] ? ChinaCityLang[d.name] : d.name
                        }));
                    } else {
                        this.china_datas = data;
                    }

                }
                this.show = true
                setTimeout(()=>{
                    this.loading = false
                }, 1000)
            })
        }
    }
}
</script>